/**
 * Infinite scroll pagination fix
 * Builds next URL by incrementing the page param instead of relying on the response
 */
// (function() {
//   function getNextPageUrl(currentUrl) {
//     if (!currentUrl) return null;
//     try {
//       const url = new URL(currentUrl, window.location.origin);
//       const page = parseInt(url.searchParams.get('page') || '1', 10);
//       url.searchParams.set('page', String(page + 1));
//       return url.pathname + url.search;
//     } catch (e) {
//       return null;
//     }
//   }

//   window.initPage = function () {
//     function e() {
//       window.swiperInstance && typeof window.swiperInstance.destroy === "function" && window.swiperInstance.destroy(!0, !0),
//         requestAnimationFrame(() => {
//           window.swiperInstance = new Swiper(".swiper-container", { lazy: !0, preloadImages: !1, slidesPerView: 1, spaceBetween: 0, loop: !0, pagination: { el: ".swiper-pagination", clickable: !0 }, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, scrollbar: { el: ".swiper-scrollbar" } });
//         });
//     }
//     document.querySelector(".swiper-container") && e(), document.addEventListener("productsLoaded", e);
//     let t = document.getElementById("NotificaitonFormEmail");
//     t && t.removeAttribute("required");
//     let o = document.getElementById("sidebar-shop-look");
//     document.querySelectorAll(".overlay-button").forEach((e) => {
//       e.addEventListener("click", function (e) {
//         e.stopPropagation(), o?.classList.add("open");
//       });
//     }),
//       document.querySelector(".sidebar-close")?.addEventListener("click", () => {
//         o?.classList.remove("open");
//       });
//     let r = document.querySelector("#CollectionLoop"),
//       i = document.querySelector("[data-loader]"),
//       a = i?.querySelector(".loader-text"),
//       d = document.querySelector(".pagination-custom__next");
//     if (r && i && d) {
//       let l = !1,
//         c = d.getAttribute("href");
//       const s = new IntersectionObserver(
//         async (e) => {
//           for (let t of e) {
//             if (!t.isIntersecting || l || !c) return;
//             (l = !0), i.classList.add("loading"), (a.textContent = "Loading more products...");
//             try {
//               const fetchUrl = c.startsWith('http') ? c : window.location.origin + c;
//               let resp = await fetch(fetchUrl),
//                 html = await resp.text(),
//                 parsed = new DOMParser().parseFromString(html, "text/html"),
//                 newItems = parsed.querySelectorAll("#CollectionLoop > *"),
//                 frag = document.createDocumentFragment();
//               newItems.forEach((el) => frag.appendChild(el));
//               r.appendChild(frag);

//               /* Build next URL by incrementing page - more reliable than response */
//               const nextFromResponse = parsed.querySelector(".pagination-custom__next")?.getAttribute("href");
//               const nextBuilt = getNextPageUrl(c);

//               if (nextFromResponse && nextFromResponse !== c) {
//                 c = nextFromResponse;
//               } else if (nextBuilt && newItems.length > 0) {
//                 c = nextBuilt;
//               } else {
//                 c = null;
//                 a.textContent = "No more products.";
//                 i.querySelector(".loader-spinner")?.remove();
//               }

//               if (c) {
//                 d.setAttribute("href", c);
//               }
//               l = !1;
//             } catch (p) {
//               console.error("Infinite Scroll Error:", p), (a.textContent = "Failed to load products.");
//               l = !1;
//             }
//             i.classList.remove("loading");
//             window.initPage();
//           }
//         },
//         { rootMargin: "600px" }
//       );
//       s.observe(i);
//     }
//   };

//   document.addEventListener("DOMContentLoaded", window.initPage);
// })();


// (document.addEventListener("DOMContentLoaded", function () {
//   function e() {
//     (window.swiperInstance && window.swiperInstance.destroy(!0, !0),
//       requestAnimationFrame(() => {
//         window.swiperInstance = new Swiper(".swiper-container", { lazy: !0, preloadImages: !1, slidesPerView: 1, spaceBetween: 0, loop: !0, pagination: { el: ".swiper-pagination", clickable: !0 }, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }, scrollbar: { el: ".swiper-scrollbar" } });
//       }));
//   }
//   (document.querySelector(".swiper-container") && e(), document.addEventListener("productsLoaded", e));
//   let t = document.getElementById("NotificaitonFormEmail");
//   t && t.removeAttribute("required");
//   let o = document.getElementById("sidebar-shop-look");
//   (document.querySelectorAll(".overlay-button").forEach((e) => {
//     e.addEventListener("click", function (e) {
//       (e.stopPropagation(), o?.classList.add("open"));
//     });
//   }),
//     document.querySelector(".sidebar-close")?.addEventListener("click", () => {
//       o?.classList.remove("open");
//     }));
//   let r = document.querySelector("#CollectionLoop"),
//     i = document.querySelector("[data-loader]"),
//     a = i?.querySelector(".loader-text"),
//     d = document.querySelector(".pagination-custom__next");
//   if (r && i && d) {
//     let l = !1,
//       c = d.getAttribute("href"),
//       s = new IntersectionObserver(
//         async (e) => {
//           for (let t of e) {
//             if (!t.isIntersecting || l || !c) return;
//             ((l = !0), i.classList.add("loading"), (a.textContent = "Loading more products..."));
//             try {
//               let e = await fetch(c),
//                 t = await e.text(),
//                 d = new DOMParser().parseFromString(t, "text/html"),
//                 s = d.querySelectorAll("#CollectionLoop > *"),
//                 n = document.createDocumentFragment();
//               (s.forEach((e) => n.appendChild(e)), r.appendChild(n));
//               let o = d.querySelector(".pagination-custom__next");
//               o && o.getAttribute("href") !== c ? ((c = o.getAttribute("href")), (l = !1)) : ((c = null), (a.textContent = "No more products."), i.querySelector(".loader-spinner")?.remove());
//             } catch (p) {
//               (console.error("Infinite Scroll Error:", p), (a.textContent = "Failed to load products."));
//             }
//             i.classList.remove("loading");
//           }
//         },
//         { rootMargin: "600px" },
//       );
//     s.observe(i);
//   }
// }),
//   $(document).on("click", ".product-card-color", function () {
//     var e = $(this).data("color-id"),
//       t = $(this).closest(".product-item"),
//       o = t.find(".product-item__image[data-color-id]"),
//       r = t.find(".product-link[data-color-id]"),
//       i = t.find(".material2[data-color-id]"),
//       a = t.find(".product-card-color[data-color-id] .color-row-subinner");
//     (o
//       .addClass("hide")
//       .filter('[data-color-id="' + e + '"]')
//       .removeClass("hide"),
//       r
//         .addClass("hide")
//         .filter('[data-color-id="' + e + '"]')
//         .removeClass("hide"),
//       i
//         .addClass("hide")
//         .filter('[data-color-id="' + e + '"]')
//         .removeClass("hide"),
//       a.removeClass("active"),
//       t.find('.product-card-color[data-color-id="' + e + '"] .color-row-subinner').addClass("active"));
//   }));



function initCustomFeatures() {

  /* -----------------------------
     Swiper Init
  ----------------------------- */
  function initSwiper() {
    // if (window.swiperInstance) {
    //   window.swiperInstance.destroy(true, true);
    // }

    requestAnimationFrame(() => {
      window.swiperInstance = new Swiper(".swiper-container", {
        lazy: true,
        preloadImages: false,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        }
      });
    });
  }

  if (document.querySelector(".swiper-container")) {
    initSwiper();
  }

  document.addEventListener("productsLoaded", initSwiper);
}


document.addEventListener("DOMContentLoaded", function() {
  initCustomFeatures();
});

// jQuery color switcher (runs independently)
$(document).on("click", ".product-card-color", function () {
  var e = $(this).data("color-id"),
    t = $(this).closest(".product-item"),
    o = t.find(".product-item__image[data-color-id]"),
    r = t.find(".product-link[data-color-id]"),
    i = t.find(".material2[data-color-id]"),
    a = t.find(".product-card-color[data-color-id] .color-row-subinner");
  o.addClass("hide").filter('[data-color-id="' + e + '"]').removeClass("hide"),
    r.addClass("hide").filter('[data-color-id="' + e + '"]').removeClass("hide"),
    i.addClass("hide").filter('[data-color-id="' + e + '"]').removeClass("hide"),
    a.removeClass("active"),
    t.find('.product-card-color[data-color-id="' + e + '"] .color-row-subinner').addClass("active");
});
// Top bar rotation (Weglot compatible)
window.addEventListener("load", function () {

  const wrap = document.querySelector(".ai-top-bar-left-av1lnqvhjog9wcmvmzaigenblock3262fb3tydm9p");
  if (!wrap) return;

  const items = Array.from(wrap.querySelectorAll(".ad-rot-item"));
  if (items.length <= 1) return;

const linkEl = wrap.querySelector("a") || wrap.closest("a");
  const root = window.Shopify?.routes?.root || "/";

  let i = 0;

  function updateItem(index) {
    items.forEach((el, idx) => {
      el.style.display = idx === index ? "inline" : "none";
    });

    if (linkEl) {
      const href = items[index].getAttribute("data-href");
      if (href) {
        const clean = href.startsWith("/") ? href.slice(1) : href;
        linkEl.setAttribute("href", root + clean);
      }
    }
  }

  updateItem(i);

  setInterval(function () {
    i = (i + 1) % items.length;
    updateItem(i);
  }, 4500);

});
